var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedAave0)",
    d: "M17.949 16.854L13.526 5.98a1.2 1.2 0 0 0-.423-.6a1.18 1.18 0 0 0-.688-.236h-.388a1.18 1.18 0 0 0-.686.238c-.2.15-.347.36-.422.598l-1.923 4.74l-1.18-.005c-1.286 0-1.286 1.714 0 1.714h.503l-1.834 4.426a1 1 0 0 0-.056.309a.86.86 0 0 0 .216.604a.76.76 0 0 0 .588.232a.8.8 0 0 0 .456-.155a1 1 0 0 0 .313-.407l2.025-5.009h.988c1.302 0 1.302-1.714.01-1.714l-.347.004l1.543-3.921l4.206 10.64a1 1 0 0 0 .313.407a.8.8 0 0 0 .456.155a.75.75 0 0 0 .592-.232a.86.86 0 0 0 .212-.604a.7.7 0 0 0-.051-.309"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedAave0",
    x1: 18.517,
    x2: 4.817,
    y1: 4.569,
    y2: 16.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B14992"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#925C9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#647BA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671,
    stopColor: "#3896B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.956,
    stopColor: "#00ABBB"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAave);
export default __webpack_public_path__ + "static/media/aave.0a090927722fe4377a9c02ebc491344b.svg";
export { ForwardRef as ReactComponent };